import { DataGridTypes } from 'devextreme-react/data-grid';

import FieldColorHelper from '../../tools/FieldColorHelper';

import FieldReferenceDto from '../../classes/dtos/datastructuremodule/FieldReferenceDto';

const FieldTypeCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {

    let fieldReferenceDto = cellData.data as FieldReferenceDto;
    let tagColor = FieldColorHelper.GetTagColor(fieldReferenceDto.Type);
    let textColor = FieldColorHelper.GetTextColor(fieldReferenceDto.Type);

    return (
        <div style={{ width: 'auto', height: 22, paddingLeft: 10, paddingRight: 10, paddingTop: 2, paddingBottom: 2, background: tagColor, borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 6, display: 'inline-flex' }}>
            <div style={{ textAlign: 'center', color: textColor, fontSize: 10, fontFamily: 'Manrope', fontWeight: '500', textTransform: 'uppercase', letterSpacing: 1, wordWrap: 'break-word' }}>{fieldReferenceDto.TypeLabel}</div>
        </div>
    )
};

export default FieldTypeCell;
